/* ============================================================
   MR. HOOF — shared interactions (Apple-flavoured)
   ============================================================ */

(function () {
  // -- Word splitting (preserves <br>, <em>, inline tags) ---------
  function splitWords(root) {
    if (root.dataset.split === '1') return;
    let i = 0;
    function walk(node) {
      if (node.nodeType === 3) {
        const parts = node.textContent.split(/(\s+)/);
        if (parts.length === 1 && !parts[0].trim()) return;
        const frag = document.createDocumentFragment();
        parts.forEach(p => {
          if (!p.length) return;
          if (/^\s+$/.test(p)) {
            frag.appendChild(document.createTextNode(p));
          } else {
            const span = document.createElement('span');
            span.className = 'w';
            span.style.setProperty('--i', i++);
            span.textContent = p;
            frag.appendChild(span);
          }
        });
        node.parentNode.replaceChild(frag, node);
        return;
      }
      if (node.nodeType === 1) {
        if (node.tagName === 'BR') return;
        Array.from(node.childNodes).forEach(walk);
      }
    }
    Array.from(root.childNodes).forEach(walk);
    root.dataset.split = '1';
  }
  document.querySelectorAll('.word-reveal').forEach(splitWords);

  // -- Intersection-based reveal --------------------------------
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        if (e.target.dataset.revealOnce !== 'no') io.unobserve(e.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('[data-reveal], .word-reveal, .cine-img').forEach(el => io.observe(el));

  // -- Counter animation ---------------------------------------
  const counterIo = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const target = parseFloat(el.dataset.count);
      const decimals = parseInt(el.dataset.decimals || '0');
      const prefix = el.dataset.prefix || '';
      const suffix = el.dataset.suffix || '';
      const duration = parseFloat(el.dataset.duration || '2200');
      const start = performance.now();
      function tick(now) {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 4);
        const val = target * eased;
        el.textContent = prefix + (decimals ? val.toFixed(decimals) : Math.round(val).toLocaleString('nl-NL')) + suffix;
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      counterIo.unobserve(el);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach(el => counterIo.observe(el));

  // -- Sticky nav state -----------------------------------------
  const nav = document.querySelector('.nav');
  if (nav) {
    const onScroll = () => {
      if (window.scrollY > 60) nav.classList.add('solid');
      else nav.classList.remove('solid');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // -- Cursor-following glow on .glow-card ----------------------
  document.querySelectorAll('.glow-card').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  // -- Parallax (subtle) ----------------------------------------
  const parallax = document.querySelectorAll('[data-parallax]');
  if (parallax.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    const onPa = () => {
      parallax.forEach(el => {
        const rect = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const mid = window.innerHeight / 2;
        const delta = (center - mid) / window.innerHeight;
        const speed = parseFloat(el.dataset.parallax || '0.15');
        el.style.transform = `translate3d(0, ${(-delta * speed * 100).toFixed(2)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(onPa); ticking = true; }
    }, { passive: true });
    onPa();
  }

  // -- Scroll-driven scale/opacity on [data-scroll-fade] --------
  // Element fades + scales as it passes through center of viewport.
  const fadeEls = document.querySelectorAll('[data-scroll-fade]');
  if (fadeEls.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking2 = false;
    const onScroll2 = () => {
      const vh = window.innerHeight;
      fadeEls.forEach(el => {
        const r = el.getBoundingClientRect();
        const center = r.top + r.height / 2;
        // 0 when at center, 1 at edges
        const dist = Math.min(1, Math.abs(center - vh / 2) / (vh * 0.7));
        const opacity = 1 - dist * 0.55;
        const scale  = 1 - dist * 0.05;
        el.style.opacity = opacity.toFixed(3);
        el.style.transform = `scale(${scale.toFixed(3)})`;
      });
      ticking2 = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking2) { requestAnimationFrame(onScroll2); ticking2 = true; }
    }, { passive: true });
    onScroll2();
  }
})();

/* ============================================================
   Logo lockup — emitted as inline SVG (text-only placeholder
   for the horse-head mark; user can swap in real artwork later)
   ============================================================ */
function MrHoofLogoMark() {
  return `
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <!-- Stylised horse-silhouette placeholder using simple primitives.
         Replace with the real .svg when the brand mark is delivered. -->
    <circle cx="32" cy="32" r="30" stroke="currentColor" stroke-width="0.6" opacity="0.25"/>
    <path d="M22 20c2-3 6-5 10-5 6 0 10 4 10 9v3c0 2 1 3 2 4l3 3v9c0 4-3 7-7 7h-3c-1 0-2-1-2-2v-4c0-2-1-3-3-3h-4c-3 0-5-1-6-3l-2-3c-1-2-2-4-2-7 0-3 1-6 4-8z"
          fill="currentColor"/>
    <path d="M19 16c-2 2-3 4-3 7" stroke="currentColor" stroke-width="1" stroke-linecap="round" fill="none"/>
    <path d="M16 21c-2 2-3 4-3 6" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" fill="none"/>
  </svg>`;
}

// Inject logo into any .logo .mark placeholder
document.querySelectorAll('.logo .mark').forEach(el => {
  if (!el.innerHTML.trim()) el.innerHTML = MrHoofLogoMark();
});

;(function(){var t=document.querySelector('.nav-toggle'),l=document.querySelector('.nav .links');if(t&&l){t.addEventListener('click',function(){l.classList.toggle('open');});l.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){l.classList.remove('open');});});}})();

/* ============================================================
   MR. HOOF — gedeelde verpakking-parser (een bron van waarheid)
   Zowel de productpagina-picker als de productkaarten (collectie
   en zoeken) gebruiken deze parser; geen dubbele afwijkende logica.
   ============================================================ */
(function () {
  function euro(cents) {
    var v = (cents / 100);
    return '€' + v.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // leesbare verpakking -> { count, label }
  function parsePack(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    if (!s) return null;
    var low = s.toLowerCase();
    var m;
    m = low.match(/overdoos\s*(\d+)\s*[x×]\s*(\d+)/);
    if (m) { var a = parseInt(m[1], 10), b = parseInt(m[2], 10); return { count: a * b, label: a + ' dozen van ' + b, dozen: a, perDoos: b }; }
    m = low.match(/doos\s*(\d+)/);
    if (m) { var dn = parseInt(m[1], 10); return { count: dn, label: 'Doos van ' + dn + ' stuks' }; }
    if (/(^|\b)(per\s+)?paar\b/.test(low)) { return { count: 2, label: 'Per paar (2 stuks)' }; }
    m = low.match(/bundel\s*(\d+)/);
    if (m) { var bn = parseInt(m[1], 10); return { count: bn, label: 'Bundel van ' + bn + ' stuks' }; }
    m = low.match(/zakje\s*(\d+)/);
    if (m) { var zn = parseInt(m[1], 10); return { count: zn, label: 'Zakje van ' + zn + ' stuks' }; }
    if (/(^|\b)(per\s+)?stuks?\b/.test(low)) { return { count: 1, label: 'Per stuk' }; }
    return { count: null, label: s };
  }
  // korte, klantvriendelijke kaartregel: "per doos van 250", "per paar", ...
  function cardLabel(raw) {
    var info = parsePack(raw);
    if (!info) return '';
    var low = String(raw).toLowerCase();
    var m;
    m = low.match(/overdoos\s*(\d+)\s*[x×]\s*(\d+)/);
    if (m) return parseInt(m[1],10) + ' dozen van ' + parseInt(m[2],10);
    m = low.match(/doos\s*(\d+)/);
    if (m) return 'Per doos van ' + parseInt(m[1],10);
    if (info.count === 2 && /paar/.test(low)) return 'Per paar';
    m = low.match(/bundel\s*(\d+)/);
    if (m) return 'Per bundel van ' + parseInt(m[1],10);
    m = low.match(/zakje\s*(\d+)/);
    if (m) return 'Per zakje van ' + parseInt(m[1],10);
    if (info.count === 1) return 'Per stuk';
    return info.label;
  }
  // weergave-label voor een optiewaarde in de picker: "Overdoos AxB" -> "A dozen van B".
  // Alleen de weergegeven tekst verandert; de onderliggende optiewaarde blijft ongemoeid.
  function optionLabel(raw) {
    if (!raw) return raw;
    var s = String(raw);
    var m = s.toLowerCase().match(/overdoos\s*(\d+)\s*[x×]\s*(\d+)/);
    if (m) return parseInt(m[1], 10) + ' dozen van ' + parseInt(m[2], 10);
    return s;
  }
  window.MrHoofPack = { parse: parsePack, cardLabel: cardLabel, optionLabel: optionLabel, euro: euro };

  // -- kaarten: kleinste-verpakkingsregel invullen ----------------
  function fillCards(root) {
    (root || document).querySelectorAll('.pcard-pack[data-pack-raw]').forEach(function (el) {
      if (el.dataset.packDone === '1') return;
      var raw = el.getAttribute('data-pack-raw');
      var info = parsePack(raw);
      var txt;
      if (info && info.dozen && info.dozen > 1) {
        var totaal = el.getAttribute('data-pack-totaal');
        txt = 'Per doos van ' + info.perDoos + ' \u00b7 ' + info.dozen + ' dozen' + (totaal ? ' (' + totaal + ' totaal)' : '');
      } else {
        txt = cardLabel(raw);
      }
      if (txt) { el.textContent = txt; el.dataset.packDone = '1'; }
      else { el.remove(); }
    });
  }
  window.MrHoofPack.fillCards = fillCards;
  fillCards(document);
})();

/* ============================================================
   MR. HOOF — productpagina: slimme variant-picker + prijs + verpakkingsregel
   ============================================================ */
(function () {
  var dataEl = document.getElementById('mh-variant-data');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = (data && data.variants) || [];
  if (!variants.length) return;

  var isB2b = !!data.b2b;
  // b2b-kortingsfactor uit het thema (0.80 bij 20%, 0.85 bij 15%); valt terug op 0.85.
  var b2bMult = (typeof data.b2bMult === 'number') ? data.b2bMult : 0.85;
  // Consument (geen b2b) ziet alles inclusief 21% btw (verzoek Jelle 14-08);
  // zakelijk blijft exclusief. Alleen de weergave schaalt; de variant-data
  // en de kar blijven in ex-btw-centen.
  var toonFactor = isB2b ? 1 : 1.21;
  function toon(cents) { return euro(Math.round(cents * toonFactor)); }
  var priceEl   = document.getElementById('mh-price');       // normale prijs
  var priceOld  = document.getElementById('mh-price-old');   // b2b: doorgestreepte adviesprijs
  var priceB2b  = document.getElementById('mh-price-b2b');   // b2b: jouw prijs
  var packEl    = document.getElementById('mh-pack');        // verpakkingsregel
  var idInput   = document.getElementById('mh-variant-id');  // verborgen name="id"
  var imgEl     = document.getElementById('mh-pdp-img');     // hoofdfoto (wisselt mee met de gekozen variant)
  var picker    = document.getElementById('mh-picker');      // wrapper met de selects (kan ontbreken bij 1 variant)
  var selects   = picker ? Array.prototype.slice.call(picker.querySelectorAll('select[data-opt-index]')) : [];

  // Optiewaarden zoals "Overdoos 16x250" tonen als "16 dozen van 250".
  // Alleen de zichtbare tekst wordt herschreven; de option-value (waarop de
  // variant-matching werkt) blijft exact de ruwe waarde.
  if (selects.length && window.MrHoofPack && window.MrHoofPack.optionLabel) {
    selects.forEach(function (s) {
      Array.prototype.forEach.call(s.options, function (opt) {
        var nice = window.MrHoofPack.optionLabel(opt.value);
        if (nice !== opt.value) opt.textContent = nice;
      });
    });
  }

  // ---- geld-notatie: cent -> "€12,34" (exact zoals het money-filter van het thema) ----
  function euro(cents) {
    var v = (cents / 100);
    return '€' + v.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // per-stuk houden we op 2 decimalen aan, gelijk aan de rest van de shop.
  function euroPer(cents) {
    return euro(cents);
  }

  // ---- verpakking-parser: gedeeld met de kaarten (window.MrHoofPack) --
  function parsePack(raw) {
    return (window.MrHoofPack && window.MrHoofPack.parse) ? window.MrHoofPack.parse(raw) : null;
  }

  // ---- nettoprijs voor een variant: actieprijs of b2b-prijs ------
  // Actieproduct (compareAt > price): iedereen betaalt de vaste actieprijs;
  // alleen een b2b-percentage boven de actiekorting geeft een lagere nettoprijs.
  function nettoPrijs(variant) {
    var promo = variant.compareAt && variant.compareAt > variant.price;
    if (promo) {
      var net = variant.price;
      if (isB2b) {
        var b2bNet = Math.round(variant.compareAt * b2bMult);
        if (b2bNet < net) net = b2bNet;
      }
      return net;
    }
    return isB2b ? Math.round(variant.price * b2bMult) : variant.price;
  }

  // ---- verpakkingsregel renderen voor een variant ----------------
  function doosDeler(variant) {
    var info = parsePack(variant.verpakking);
    return (info && info.dozen && info.dozen > 1) ? info.dozen : 1;
  }

  function renderPack(variant) {
    if (!packEl) return;
    var info = parsePack(variant.verpakking);
    if (!info) { packEl.hidden = true; packEl.textContent = ''; return; }
    var html;
    if (info.dozen && info.dozen > 1) {
      // overdoos: de hoofdprijs is per doos; hier de uitleg plus het totaal
      var totaal = Math.round(nettoPrijs(variant) * toonFactor);
      html = '<span class="mh-pack-label">Per doos van ' + info.perDoos + '</span>' +
             ' <span class="mh-pack-per">(' + info.dozen + ' dozen \u00b7 ' + euro(totaal) + ' totaal)</span>';
    } else {
      html = '<span class="mh-pack-label">' + info.label + '</span>';
      if (info.count && info.count > 1) {
        // per-stuk = nettoprijs (in cent) gedeeld door aantal
        var per = (nettoPrijs(variant) * toonFactor) / info.count;
        html += ' <span class="mh-pack-per">(' + euroPer(per) + ' per stuk)</span>';
      }
    }
    packEl.innerHTML = html;
    packEl.hidden = false;
  }

  // ---- prijs meebewegen ------------------------------------------
  function renderPrice(variant) {
    var d = doosDeler(variant);
    var promo = variant.compareAt && variant.compareAt > variant.price;
    if (promo && priceOld && priceB2b) {
      priceOld.textContent = euro(Math.round(variant.compareAt * toonFactor / d));
      priceB2b.textContent = euro(Math.round(nettoPrijs(variant) * toonFactor / d));
      return;
    }
    if (isB2b) {
      if (priceOld) priceOld.textContent = euro(Math.round(variant.price / d));
      if (priceB2b) priceB2b.textContent = euro(Math.round(variant.price * b2bMult / d));
    } else if (priceEl) {
      priceEl.textContent = euro(Math.round(variant.price * toonFactor / d));
    }
  }

  // ---- variant zoeken op een volledige combinatie ----------------
  // sel = array van gekozen optiewaarden per as (kan null bevatten = vrij)
  function findVariant(sel, preferAvailable) {
    var fallback = null;
    for (var i = 0; i < variants.length; i++) {
      var vv = variants[i];
      var ok = true;
      for (var k = 0; k < sel.length; k++) {
        if (sel[k] != null && vv.options[k] !== sel[k]) { ok = false; break; }
      }
      if (!ok) continue;
      if (!preferAvailable) return vv;
      if (vv.available) return vv;
      if (!fallback) fallback = vv;
    }
    return fallback;
  }

  // ---- unieke waarden per as, in de volgorde van de dropdown -----
  function valuesForAxis(axis) {
    var s = selects[0];
    // vind de select van deze as om de gerenderde volgorde te respecteren
    for (var i = 0; i < selects.length; i++) {
      if (parseInt(selects[i].getAttribute('data-opt-index'), 10) === axis) { s = selects[i]; break; }
    }
    return Array.prototype.map.call(s.options, function (o) { return o.value; });
  }

  // ---- bereikbaar: bestaat er een variant met de keuzes op de -----
  // assen VOOR `axis` plus `val` op `axis`? (prefix-cascade)
  function reachable(sel, axis, val) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[axis] !== val) continue;
      var ok = true;
      for (var k = 0; k < axis; k++) {
        if (sel[k] != null && v.options[k] !== sel[k]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  // ---- eerste geldige waarde voor `axis` gegeven de eerdere assen -
  function firstValid(sel, axis, preferAvailable) {
    var vals = valuesForAxis(axis);
    var fb = null;
    for (var i = 0; i < vals.length; i++) {
      if (!reachable(sel, axis, vals[i])) continue;
      if (!preferAvailable) return vals[i];
      // beschikbaarheid checken via een complete match met deze prefix
      var probe = sel.slice();
      probe[axis] = vals[i];
      for (var j = axis + 1; j < data.optionCount; j++) probe[j] = null;
      var m = findVariant(probe, true);
      if (m) return vals[i];
      if (!fb) fb = vals[i];
    }
    return fb;
  }

  // ---- huidige keuze uit de selects lezen ------------------------
  function readSelection() {
    var sel = [];
    for (var i = 0; i < data.optionCount; i++) sel[i] = null;
    selects.forEach(function (s) {
      sel[parseInt(s.getAttribute('data-opt-index'), 10)] = s.value;
    });
    return sel;
  }

  // ---- onmogelijke opties uitschakelen (prefix-cascade) ----------
  // Voor as `axis` is een waarde kiesbaar als er een variant bestaat
  // die klopt met de keuzes op de assen VOOR `axis` plus die waarde.
  // De eerste as houdt dus altijd al zijn echte waarden.
  function refreshDisabled(sel) {
    selects.forEach(function (s) {
      var axis = parseInt(s.getAttribute('data-opt-index'), 10);
      Array.prototype.forEach.call(s.options, function (opt) {
        opt.disabled = !reachable(sel, axis, opt.value);
      });
    });
  }

  // ---- assen na de gewijzigde as herstellen naar geldige waarden -
  function cascade(sel, changedAxis) {
    var out = sel.slice();
    for (var axis = changedAxis + 1; axis < data.optionCount; axis++) {
      if (out[axis] == null || !reachable(out, axis, out[axis])) {
        out[axis] = firstValid(out, axis, true);
      }
    }
    return out;
  }

  // ---- reageren op een keuze -------------------------------------
  function reconcile(changedAxis) {
    var sel = cascade(readSelection(), changedAxis);
    var target = findVariant(sel, true) || findVariant(sel, false);

    if (!target) {
      // Zou via de UI niet mogen (onbereikbare waarden zijn disabled),
      // maar voor de zekerheid: houd de gewijzigde as vast, laat de rest los.
      var partial = [];
      for (var i = 0; i < data.optionCount; i++) partial[i] = null;
      if (changedAxis != null && changedAxis >= 0) partial[changedAxis] = readSelection()[changedAxis];
      target = findVariant(partial, true) || findVariant(partial, false) || variants[0];
    }

    setSelects(target);
    refreshDisabled(readSelection());
    applyVariant(target);
  }

  // ---- alle selects op de optiewaarden van een variant zetten ----
  function setSelects(variant) {
    selects.forEach(function (s) {
      var axis = parseInt(s.getAttribute('data-opt-index'), 10);
      if (variant.options[axis] != null) s.value = variant.options[axis];
    });
  }

  // ---- variant toepassen: id, prijs, verpakking, foto ------------
  function applyVariant(variant) {
    if (idInput) idInput.value = variant.id;
    renderPrice(variant);
    renderPack(variant);
    // hoofdfoto meelaten wisselen met de variant (bv. kleur); alleen als die variant een eigen foto heeft
    if (imgEl && variant.image) imgEl.src = variant.image;
  }

  // ---- beste startvariant: beschikbaar en kleinste verpakking ----
  function pickStart() {
    var best = null, bestCount = Infinity;
    for (var i = 0; i < variants.length; i++) {
      var vv = variants[i];
      if (!vv.available) continue;
      var info = parsePack(vv.verpakking);
      var c = (info && info.count) ? info.count : Infinity;
      if (c < bestCount) { bestCount = c; best = vv; }
    }
    // Geen beschikbare variant met verpakking: val terug op de eerste beschikbare, dan de eerste.
    if (!best) {
      for (var j = 0; j < variants.length; j++) { if (variants[j].available) { best = variants[j]; break; } }
    }
    return best || variants[0];
  }

  // ---- init ------------------------------------------------------
  if (selects.length) {
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        reconcile(parseInt(s.getAttribute('data-opt-index'), 10));
      });
    });
    var start = pickStart();
    setSelects(start);
    refreshDisabled(readSelection());
    applyVariant(start);
  } else {
    // Eenvariant-product: geen picker, maar wel de verpakkingsregel en de juiste prijs.
    applyVariant(variants[0]);
  }
})();

/* ============================================================
   MR. HOOF — favorieten (localStorage, geen account nodig)
   ============================================================ */
(function () {
  var KEY = 'mrhoof_favorites';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return list.indexOf(handle) !== -1;
  }

  // Teller in de header bijwerken
  function refreshCount() {
    var n = read().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  // Eén knop synchroniseren met de opgeslagen staat
  function syncButton(btn) {
    var handle = btn.getAttribute('data-fav-handle');
    var on = has(handle);
    btn.classList.toggle('is-fav', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Verwijder uit favorieten' : 'Bewaar als favoriet');
  }

  function syncAll() {
    document.querySelectorAll('[data-fav-toggle]').forEach(syncButton);
    refreshCount();
  }

  // Klik-afhandeling via delegatie (werkt ook voor later toegevoegde kaarten)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fav-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-fav-handle');
    if (!handle) return;
    toggle(handle);
    // Alle knoppen voor dit product synchroniseren (kan op meerdere plekken staan)
    document.querySelectorAll('[data-fav-toggle][data-fav-handle="' + handle + '"]').forEach(syncButton);
    refreshCount();
    // Op de favorietenpagina: verwijderde kaart weghalen
    if (document.body.getAttribute('data-fav-page') === '1' && !has(handle)) {
      var card = btn.closest('.pcard');
      if (card) card.remove();
      var wrap = document.getElementById('mh-fav-grid');
      var empty = document.getElementById('mh-fav-empty');
      if (wrap && empty && wrap.querySelectorAll('.pcard').length === 0) {
        wrap.hidden = true; empty.hidden = false;
      }
    }
  });

  // Aan andere scripts blootstellen (favorietenpagina gebruikt read/has)
  window.MrHoofFav = { read: read, has: has, toggle: toggle, refreshCount: refreshCount, syncAll: syncAll };

  syncAll();
})();

/* ============================================================
   MR. HOOF — collectie: filter-dropdowns (details) netjes gedragen
   De filterkeuzes zelf zijn gewone <a href> naar de native
   ?filter...-URL (server-side, werkt over de HELE collectie).
   Dit script regelt alleen het openen/sluiten van de panelen.
   ============================================================ */
(function () {
  var filters = Array.prototype.slice.call(document.querySelectorAll('.mh-filter[data-filter]'));
  if (!filters.length) return;

  // maar een paneel tegelijk open
  filters.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        filters.forEach(function (o) { if (o !== d) o.open = false; });
      }
    });
  });
  // buitenklik sluit
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.mh-filter')) return;
    filters.forEach(function (d) { d.open = false; });
  });
  // Escape sluit
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') filters.forEach(function (d) { d.open = false; });
  });
})();

/* ============================================================
   MR. HOOF — collectie: sorteren met behoud van actieve filters
   ============================================================ */
(function () {
  var sel = document.querySelector('select[data-sort-select]');
  if (!sel) return;
  sel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    // paginering resetten bij een nieuwe sortering
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

/* ============================================================
   MR. HOOF — infinite scroll (collectie + zoeken)
   Laadt de volgende gepagineerde pagina bij en voegt de kaarten
   toe. De filter-URL is leidend: paginate.next.url draagt alle
   actieve ?filter...- en sort_by-params mee. Nieuwe kaarten
   krijgen de favorieten-staat en de verpakkingsregel opnieuw.
   ============================================================ */
(function () {
  var grid = document.querySelector('[data-infinite-grid]');
  var sentinel = document.querySelector('[data-infinite-sentinel]');
  if (!grid || !sentinel) return;

  var loader = document.querySelector('[data-infinite-loader]');
  var countEl = document.querySelector('[data-coll-count]');
  var loading = false;
  var done = !sentinel.getAttribute('data-next-url');

  function reinit(nodes) {
    // favorieten-staat op de nieuwe knoppen zetten
    if (window.MrHoofFav && window.MrHoofFav.syncAll) window.MrHoofFav.syncAll();
    // verpakkingsregels invullen op de nieuwe kaarten
    if (window.MrHoofPack && window.MrHoofPack.fillCards) window.MrHoofPack.fillCards(grid);
    // reveal-observer laten rusten: kaarten zijn direct zichtbaar
  }

  function loadNext() {
    if (loading || done) return;
    var next = sentinel.getAttribute('data-next-url');
    if (!next) { done = true; return; }
    loading = true;
    if (loader) loader.hidden = false;
    fetch(next, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-infinite-grid]');
        var cards = newGrid ? Array.prototype.slice.call(newGrid.children) : [];
        cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        reinit();
        // volgende pagina uit de nieuw geladen sentinel halen
        var newSentinel = doc.querySelector('[data-infinite-sentinel]');
        var nn = newSentinel ? newSentinel.getAttribute('data-next-url') : null;
        if (nn) { sentinel.setAttribute('data-next-url', nn); }
        else { sentinel.removeAttribute('data-next-url'); done = true; }
        loading = false;
        if (loader) loader.hidden = true;
        // meteen doorladen als de sentinel nog in beeld is (korte pagina's)
        if (!done) requestAnimationFrame(function () { checkVisible(); });
      })
      .catch(function () {
        loading = false;
        if (loader) loader.hidden = true;
        // bij een fout een handmatige knop tonen zodat de klant verder kan
        showManual();
      });
  }

  function showManual() {
    if (document.querySelector('.mh-loadmore-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mh-loadmore-btn';
    btn.textContent = 'Meer laden';
    btn.addEventListener('click', function () { btn.remove(); loadNext(); });
    sentinel.parentNode.insertBefore(btn, sentinel.nextSibling);
  }

  var io = null;
  function checkVisible() {
    if (done || loading) return;
    var r = sentinel.getBoundingClientRect();
    if (r.top < window.innerHeight + 700) loadNext();
  }

  // IntersectionObserver als primaire trigger ...
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
    }, { rootMargin: '700px 0px' });
    io.observe(sentinel);
  }
  // ... plus een throttled scroll/resize-terugval, zodat het bijladen ook
  // werkt als de observer op een pagina onbetrouwbaar is. Geen dubbel laden:
  // loadNext bewaakt zelf de loading/done-status.
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; checkVisible(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // eerste controle voor het geval de sentinel al (bijna) in beeld staat
  requestAnimationFrame(checkVisible);
  // lichte veiligheidspoll: vangt zeldzame gevallen waarin scroll- en
  // observer-events niet doorkomen. Stopt zichzelf zodra alles geladen is.
  var poll = setInterval(function () {
    if (done) { clearInterval(poll); return; }
    checkVisible();
  }, 500);
})();

/* ============================================================
   MR. HOOF — header: predictive search paneel
   Suggesties tijdens typen via /search/suggest.json.
   ============================================================ */
(function () {
  var openBtn = document.querySelector('[data-search-open]');
  var panel = document.getElementById('mh-searchpanel');
  if (!openBtn || !panel) return;

  var backdrop = document.querySelector('[data-search-backdrop]');
  var input = panel.querySelector('[data-search-input]');
  var closeBtn = panel.querySelector('[data-search-close]');
  var form = panel.querySelector('[data-search-form]');
  var suggestWrap = panel.querySelector('[data-search-suggest]');
  var timer = null;
  var lastQ = '';
  var activeIdx = -1;

  function open() {
    panel.hidden = false;
    if (backdrop) backdrop.hidden = false;
    // reflow forceren voor de transitie
    void panel.offsetWidth;
    panel.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 60);
  }
  function close() {
    panel.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    activeIdx = -1;
    setTimeout(function () {
      panel.hidden = true;
      if (backdrop) backdrop.hidden = true;
    }, 420);
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('open')) close();
  });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // suggest.json geeft de prijs als kaal decimaal ("4.71"); netjes naar "€4,71".
  function money(raw) {
    if (raw == null || raw === '') return '';
    var n = parseFloat(String(raw).replace(',', '.'));
    if (isNaN(n)) return esc(raw);
    return '€' + n.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // width-parameter veilig aan een CDN-url hangen
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function render(q, data) {
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    var html = '';
    if (products.length) {
      html += '<div class="mh-shead">Producten</div>';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        var priceHtml = p.price ? '<span class="mh-sprice">' + money(p.price) + '</span>' : '';
        html += '<a class="mh-sopt" href="' + esc(p.url) + '" role="option">' +
          '<span class="mh-sthumb">' + (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="mh-sbody">' +
            '<span class="mh-svendor">' + esc(p.vendor || '') + '</span>' +
            '<span class="mh-stitle">' + esc(p.title) + '</span>' +
          '</span>' + priceHtml +
        '</a>';
      });
    }
    // altijd een "zoek op ..."-rij naar de volle resultatenpagina
    html += '<a class="mh-squery" href="/search?type=product&q=' + encodeURIComponent(q) + '" role="option">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" style="width:15px;height:15px;"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
      'Alle resultaten voor &ldquo;' + esc(q) + '&rdquo;</a>';
    if (!products.length) {
      html = '<div class="mh-shead">Geen directe suggesties</div>' + html;
    }
    suggestWrap.innerHTML = html;
    activeIdx = -1;
  }

  function fetchSuggest(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (input.value.trim() === q) render(q, data); })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q === lastQ) return;
    lastQ = q;
    clearTimeout(timer);
    if (q.length < 2) { suggestWrap.innerHTML = ''; return; }
    timer = setTimeout(function () { fetchSuggest(q); }, 180);
  });

  // toetsenbordnavigatie door de suggesties
  input.addEventListener('keydown', function (e) {
    var opts = Array.prototype.slice.call(suggestWrap.querySelectorAll('.mh-sopt, .mh-squery'));
    if (!opts.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, opts.length - 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, 0); }
    else if (e.key === 'Enter') { if (activeIdx >= 0) { e.preventDefault(); opts[activeIdx].click(); return; } }
    else return;
    opts.forEach(function (o, i) { o.classList.toggle('mh-sactive', i === activeIdx); });
    if (opts[activeIdx]) opts[activeIdx].scrollIntoView({ block: 'nearest' });
  });
})();

/* ==========================================================================
   MR. HOOF - maten op volgorde
   Sorteert de Maat-optie overal op de canonieke maatladder: de Nx0-maten eerst
   (meer nullen = kleiner, dus 7x0 voor 2x0), dan de nagelmaat 00, dan numeriek
   oplopend (ook halve maten en mm-maten), en niet-numerieke maten achteraan.
   Raakt uitsluitend de optie/het filter met de naam "Maat"; lip, dimensie en
   verpakking blijven onaangeroerd. Puur presentatie: de option-values en de
   variant-matching veranderen niet. Faalt de sortering, dan blijft de pagina
   gewoon werken (ongesorteerd).
   ========================================================================== */
(function () {
  function maatKey(raw) {
    var v = String(raw == null ? '' : raw).trim();
    var m = v.match(/^(\d+)\s*[xX]0$/);            // 2x0..7x0
    if (m) return -parseInt(m[1], 10) - 0.5;       // 7x0 -> -7.5 ... 2x0 -> -2.5
    if (v === '00') return -0.25;                  // nagelmaat 00 vlak voor 0
    if (/^\d+(?:[.,]\d+)?$/.test(v)) return parseFloat(v.replace(',', '.'));
    // inch-maten: '1 5/8\"' en '1 3/4\"' als 1.625 en 1.75, '12\"' als 12
    var zonderInch = v.replace(/["\u2033]\s*$/, '').trim();
    var breuk = zonderInch.match(/^(\d+)?\s*(\d+)\/(\d+)$/);
    if (breuk) return (breuk[1] ? parseInt(breuk[1], 10) : 0) + parseInt(breuk[2], 10) / parseInt(breuk[3], 10);
    if (/^\d+(?:[.,]\d+)?$/.test(zonderInch)) return parseFloat(zonderInch.replace(',', '.'));
    return Number.POSITIVE_INFINITY;               // rest (tekst) achteraan
  }
  function cmp(a, b) {
    var ka = maatKey(a), kb = maatKey(b);
    if (isFinite(ka) && isFinite(kb) && ka !== kb) return ka - kb;
    if (isFinite(ka) !== isFinite(kb)) return isFinite(ka) ? -1 : 1;
    return String(a).localeCompare(String(b), 'nl', { numeric: true });
  }
  function isMaat(txt) { return txt && txt.trim().toLowerCase().indexOf('maat') === 0; }

  function sortProductDropdown() {
    var fields = document.querySelectorAll('#mh-picker .pdp-field');
    Array.prototype.forEach.call(fields, function (field) {
      var label = field.querySelector('label');
      if (!label || !isMaat(label.textContent)) return;
      var sel = field.querySelector('select');
      if (!sel) return;
      var opts = Array.prototype.slice.call(sel.options);
      opts.sort(function (a, b) { return cmp(a.value, b.value); });
      opts.forEach(function (o) { sel.appendChild(o); }); // herplaatsen behoudt value en selectie
    });
  }

  function sortCollectionFilter() {
    var fields = document.querySelectorAll('.mh-filter-field');
    Array.prototype.forEach.call(fields, function (field) {
      var lab = field.querySelector('.mh-flabel');
      if (!lab || !isMaat(lab.textContent)) return;
      var panel = field.querySelector('.mh-fpanel');
      if (!panel) return;
      var opts = Array.prototype.slice.call(panel.querySelectorAll('.mh-fopt'));
      if (opts.length < 2) return;
      opts.sort(function (a, b) {
        var an = a.querySelector('.mh-fname'), bn = b.querySelector('.mh-fname');
        return cmp(an ? an.textContent : '', bn ? bn.textContent : '');
      });
      opts.forEach(function (o) { panel.appendChild(o); });
    });
  }

  function run() {
    try { sortProductDropdown(); } catch (e) {}
    try { sortCollectionFilter(); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

